import posthog from "posthog-js";
import { ANALYTICS_EVENTS } from "@shared/analytics/events";
import type { AnalyticsEventMap } from "@/lib/analytics/types";
import { resolveTelemetryEnvironment } from "@/lib/telemetry-runtime";

const SHOWN_ERROR_MESSAGE_LIMIT = 200;
const EMAIL_ADDRESS = /[^\s@<>"'(),;:]+@[^\s@<>"'(),;:]+\.[a-z]{2,}/gi;

export function redactShownErrorMessage(message: string): string {
  return message
    .replace(EMAIL_ADDRESS, "[email]")
    .slice(0, SHOWN_ERROR_MESSAGE_LIMIT);
}

export function captureShownError(
  shown: AnalyticsEventMap[typeof ANALYTICS_EVENTS.UI_ERROR_SHOWN],
): void {
  if (resolveTelemetryEnvironment() === "development") return;
  try {
    posthog.capture(ANALYTICS_EVENTS.UI_ERROR_SHOWN, {
      ...shown,
      message: redactShownErrorMessage(shown.message),
    });
  } catch {
  }
}
